import React, { useState, useEffect, useRef } from 'react';
import styles from 'styles/headerAlt.module.css';
import Select from 'react-select';

// Images
import graphIcon from 'images/dialogue/graph.svg';
import loadingGif from 'images/loader2.webp';
import { checkForecastability } from 'api/chat';
import { updateChats } from 'slices/chat/reducer';
import { useDispatch } from 'react-redux';

const selectStyles = {
    control: (provided) => ({
        ...provided,
        opacity: 0,
        cursor: "pointer"
    }),
    menu: (provided) => ({
        ...provided,
        color: "white",
        maxWidth: "300px",
        width: "90vw",
        borderRadius: 10,
        overflow: "hidden",
        boxShadow: "0px 0px 4px 0px #7357EB40",
        backgroundColor: "#0B1723",
    }),
    option: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: "#0B1723",
        ":hover": {
            backgroundColor: "#132639",
        }
    })
};

const ForecastButton = ({
    messageData,
    messageIndex,
    selectedOption,
    onChange,
    options
}) => {

    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const containerRef = useRef(null);

    useEffect(() => {
        if (!menuIsOpen) return;
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setMenuIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuIsOpen]);

    const handleForecastability = async () => {

        if (loading) {
            return;
        }

        if (messageData?.isForecastable) {
            setMenuIsOpen(prev => !prev);
            return;
        }

        try {
            setLoading(true);
            const payload = {
                askedQuestion: messageData.askedQuestion,
                ...messageData.actualBotResponse
            }
            const response = await checkForecastability(payload);

            const updatePayload = {
                data: {
                    ...messageData,
                    isForecastable: response?.is_forecastable ?? null,
                    forecastableFields: response?.forecastable_columns ?? [],
                },
                index: messageIndex
            }

            dispatch(updateChats(updatePayload));

            if (response?.is_forecastable) {
                setMenuIsOpen(true);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }

    return (
        <div ref={containerRef} className='relative w-full flex items-center justify-center cursor-pointer'>
            <div
                onClick={handleForecastability}
                className={`absolute flex gap-2`}
            >
                <img
                    src={loading ? loadingGif : graphIcon}
                    alt="Forecast"
                    className={`h-5 w-5`}
                    title="click for forecast"
                />
                {loading ? "Checking Forecastability" : "FORECAST"}
            </div>

            <Select
                className={`absolute h-0 w-0`}
                isSearchable={false}
                options={options}
                value={selectedOption}
                backspaceRemovesValue={false}
                components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                controlShouldRenderValue={false}
                hideSelectedOptions={false}
                isClearable={false}
                onChange={(newValue) => {
                    onChange(newValue);
                }}
                menuIsOpen={menuIsOpen}
                onMenuClose={() => setMenuIsOpen(false)}
                menuPlacement={"auto"}
                styles={selectStyles}
                tabSelectsValue={false}
                maxMenuHeight={250}
            />

        </div>
    );
};

export default ForecastButton;
